import { FrownOutlined } from '@ant-design/icons';
import { Descriptions } from 'antd';
import dayjs from 'dayjs';
import { DATE_TIME_FORMAT } from '@/std/const/date';

export function ErrorComponent({ error }: { error: Error }) {
    return (
        <Descriptions
            bordered={true}
            column={1}
            size='small'
            title={
                <div className='flex items-center justify-center gap-2 pt-2'>
                    <FrownOutlined className='text-3xl' />
                    <span>Desculpe, ocorreu um erro ao carregar este componente.</span>
                </div>
            }
        >
            <Descriptions.Item label='URL'>
                <span className='break-all'>{window.location.href}</span>
            </Descriptions.Item>
            <Descriptions.Item label='Versão'>
                {APP_VERSION}-{CURRENT_COMMIT}
            </Descriptions.Item>
            <Descriptions.Item label='Data'>{dayjs().format(DATE_TIME_FORMAT)}</Descriptions.Item>
            <Descriptions.Item label='Mensagem'>
                <pre className='mt-1 whitespace-pre-wrap break-words'>{error.message}</pre>
            </Descriptions.Item>
        </Descriptions>
    );
}
